import React, { useState, useEffect } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';
import Header from '../header/header';
import Table from '../../components/table/table';
import 'aos/dist/aos.css';
import AOS from 'aos';
import '../../assets/css/global.css';
import Modal from 'react-modal';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import SpecialMessageCell from './specialMessage';
import UploadAfcAlbum from './uploadNfcAlbum';
import TitleIcon from '../../assets/images/icon-album.svg'
import ArrowCheck from '../../assets/images/icon-checkmark.svg'
import View from '../../assets/images/icon-view.svg'
import Waiting from '../../assets/images/icon-waiting.svg'
import GetNFCAlbumList from '../../apis/getNFCAlbum/getNFCAlbum';
import UploadIcon from '../../assets/images/icon-upload.svg'
import { Link, useNavigate } from 'react-router-dom';
import { useAlbum } from '../../components/privateRoute/albumContext';
import Help from '../help/help';
import IPRPopupForm from '../iprForm/iprForm';
import Footer from '../footer/footer';
import Cross from '../../assets/images/icon-cross.svg'
import Filter from '../../assets/images/Filter.svg'
import CommentIcon from '../../assets/images/comment.svg'
import Edit from '../../assets/images/edit.svg'
import EdiAlbumBanner from './editAlbumBanner';
import ViewProof from '../../assets/images/view_proof.svg'
import { ToastContainer, toast } from 'react-toastify';
import EditableAlbumCell from './editableAlbumCell';
import 'react-toastify/dist/ReactToastify.css';
const NFCWriterAppAlbum = () => {
  const { setAlbumDetails, setArtworkStatus, setAudioStatus, setNcfStatus } = useAlbum();

  const navigate = useNavigate();
  const [albums, setAlbums] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [albumsPerPage] = useState(2);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortState, setSortState] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isAlbumPopupOpen, setAlbumPopupOpen] = useState(false);
  const [isIPRPopupOpen, setIPRPopupOpen] = useState(false);
  const [helpPopupOpen, setHelpPopupOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [albumValue, setAlbumValue] = useState('');
  const [isBandPopupOpen, setBandPopupOpen] = useState(false);
  const [selectedBand, setSelectedBand] = useState(null);
  const [selectedProof, setselectedProof] = useState(null);
  const [isFilterDivOpen, setFilterDivOpen] = useState(false);
  const [selectedArtworkStatus, setSelectedArtworkStatus] = useState(-1);
  const [selectedAudioStatus, setSelectedAudioStatus] = useState(-1);
  const [selectedPrintProofStatus, setSelectedPrintProofStatus] = useState(-1);
  const [selectedIprAgreement, setSelectedIprAgreement] = useState(-1);
  const [isProofPopupOpen, setProofPopupOpen] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [userType, setUserType] = useState(null);
  const [selectedArtworkId, setSelectedArtworkId] = useState(null);
  const [repersentiveComment, setRepersentiveComment] = useState('');
  const [repersentiveStatus, setRepersentiveStatus] = useState('');
  const [commentPopupOpen, setCommentPopupOpen] = useState(false);
  const [commentHistory, setCommentHistory] = useState([]);
  const [editingAlbum, setEditingAlbum] = useState(null);
  const closeBandPopup = () => {
    setBandPopupOpen(false);
    setSelectedBand(null);
  };

  const openAlbumPopup = (album = null) => {
    setEditingAlbum(album);
    setAlbumPopupOpen(true);
  };



  useEffect(() => {
    AOS.init();
    document.body.classList.remove('home-bg');
    const storedUserType = sessionStorage.getItem('userType');
    setUserType(storedUserType);
    fetchAlbums();
  }, [pageSize]);

  const fetchAlbums = async () => {
    setLoading(true);
    const authenticationToken = sessionStorage.getItem('token');
    try {
      const response = await GetNFCAlbumList(authenticationToken);

      response.sort((a, b) => b.id - a.id);

      setAlbums(response);
      setFilteredData(response);
      const pages = Math.ceil(response.length / pageSize);
      setTotalPages(pages);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const closeAlbumPopup = () => {
    setAlbumPopupOpen(false);
    fetchAlbums();
  };

  const closeHelpPopup = () => {
    setHelpPopupOpen(false);
    fetchAlbums();
  };

  function handleSort(column) {
    const sortedData = [...filteredData];
    const currentSort = sortState[column] || "asc";
    sortedData.sort((a, b) => {
      if (currentSort === "asc") {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    const newSortState = {
      ...sortState,
      [column]: currentSort === "asc" ? "desc" : "asc"
    };
    setFilteredData(sortedData);
    setSortState(newSortState);
  }

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filteredData = albums.filter((item) => (
      item.title && item.title.toLowerCase().includes(query.toLowerCase())
    ));
    const pages = Math.ceil(filteredData.length / pageSize);
    setTotalPages(pages);
    setFilteredData(filteredData);
  };


  const handleChangePage = (page) => {
    setCurrentPage(page);
  };



  const openHelpPopup = () => {
    setHelpPopupOpen(true);
  }
  const handleClick = (id, title, albumPic, action) => {
    console.log(title)
    sessionStorage.setItem('title', title);
    sessionStorage.setItem('albumPic', albumPic);
    setAlbumDetails({ id, title, albumPic });
    switch (action) {
      case 'upload':
        navigate(`/form-for-artwork/${id}`);
        break;
      case 'audio':
        navigate(`/audio/${id}`);
        break;
      case 'track':
        navigate(`/track/${id}`);
        break;
      case 'artwork':
        navigate(`/artwork/${id}`);
        break;
      default:
        break;
    }
  };


  const closeProofPopup = () => {
    setProofPopupOpen(false);
    setSelectedAlbum(null);
    fetchAlbums();
  };

  const openCommentPopup = (albumId, status, comment, albumArtworkProofId, history) => {
    setSelectedArtworkId(albumId);
    setRepersentiveComment(comment);
    setRepersentiveStatus(status);
    setCommentHistory(history);
    setCommentPopupOpen(true);
  };

  const closeCommentPopup = () => {
    setCommentPopupOpen(false);
    fetchAlbums();
  };

  useEffect(() => {
    if (selectedBand) {
      console.log(selectedBand);
    }
  }, [selectedBand]);

  const handleFilter = () => {
    let filtered = albums;

    if (selectedArtworkStatus !== -1) {
      filtered = filtered.filter(album => album.artworkStatus === selectedArtworkStatus);
    }

    if (selectedAudioStatus !== -1) {
      filtered = filtered.filter(album => album.audioFilesStatus === selectedAudioStatus);
    }

    if (selectedPrintProofStatus !== -1) {
      filtered = filtered.filter(album => album.printProofStatus === selectedPrintProofStatus);
    }

    if (selectedIprAgreement !== -1) {
      filtered = filtered.filter(album => album.iprAgreement === selectedIprAgreement);
    }

    setFilteredData(filtered);
    setTotalPages(Math.ceil(filtered.length / pageSize));
    setFilterDivOpen(false);
  };

  const handleClearFilters = () => {
    setSelectedArtworkStatus(-1);
    setSelectedAudioStatus(-1);
    setSelectedPrintProofStatus(-1);
    setSelectedIprAgreement(-1);
    setFilteredData(albums);
    setTotalPages(Math.ceil(albums.length / pageSize));
  };
  const handleEditClick = (album) => {
    setEditingAlbum(album)
    openAlbumPopup(album);
  }
  const columns = [


    {
      title: 'Album',
      dataKey: 'title',
      sortable: true,
      minwidth: 200,

      renderer: (rowData) => (
        <EditableAlbumCell
          rowData={rowData}
          onSave={(id, updatedTitle) => {
            console.log("Save Album:", id, updatedTitle);
            // call API or update state here
          }}
        />
      )
    },
    {
      title: 'Banner',
      dataKey: 'albumPic',
      sortable: true,
      minwidth: 180,
      renderer: (rowData) => (
        <EdiAlbumBanner
          rowData={rowData}
          onSave={(id, newFile) => {
            console.log("Save Banner:", id, newFile);
            // call API upload here with FormData
          }}
        />
      ),
    },


    {
      title: 'Description',
      dataKey: 'description',
      minwidth: 200,

      renderer: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {rowData.description}
        </div>
      )
    },
     {
      title: 'Card Counts',
      dataKey: 'cardsCount',
      minwidth: 130,
      renderer: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {rowData.cardsCount}
        </div>
      )
    },
    {
      title: 'Track Counts',
      dataKey: 'trackCount',
      minwidth: 130,
      renderer: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {rowData.trackCount}
        </div>
      )
    },
  {
  title: 'Type',
  dataKey: 'type',
  minWidth: 130,
  renderer: (rowData) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {rowData.type === 1 ? 'Album' : rowData.type === 2 ? 'Event' : ''}
    </div>
  )
},


    {
      title: 'Public Library',
      dataKey: 'isPublicLibrary',
      minwidth: 140,
      renderer: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {rowData.isPublicLibrary ? 'Yes' : 'No'}
        </div>
      )
    }
    ,
    {
      title: 'Special Message',
      dataKey: 'specialMessage',
      minwidth: 160,
      renderer: (rowData) => (
        <SpecialMessageCell
          rowData={rowData}
          onUpdate={(id, newMessage) => {
            setAlbums(prev =>
              prev.map(item => (item.id === id ? { ...item, specialMessage: newMessage } : item))
            );
          }}
          onDelete={(id) => {
            setAlbums(prev => prev.filter(item => item.id !== id));
          }}
        />
      ),
    }


    ,
    {
      title: 'Status',
      dataKey: 'status',
      minwidth: 95,
      renderer: (rowData) => {
        let statusText = '';
        switch (rowData.status) {
          case 0:
            statusText = 'InActive';
            break;
          case 1:
            statusText = 'Active';
            break;

          default:
            statusText = 'Unknown';
        }
        return <div>{statusText}</div>;
      }
    }
    ,
    {
      title: '',
      dataKey: 'albumId',
      sortable: false,
      minwidth: 60,
      renderer: (rowData) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button onClick={() => handleEditClick(rowData)} className='EditIconButton' style={{
            cursor: rowData.iprAgreement === 0 ? 'default' : 'pointer',
            opacity: rowData.iprAgreement === 0 ? 0.5 : 1,
            padding: '0px 20px 0px 7px'
          }}><img src={Edit} alt="View" className='EditIcon' width={24} height={20} /></button>

        </div>
      )
    },

    {
      title: '',
      dataKey: 'view',
      minwidth: 60,
      renderer: (rowData) => (
        <div>
          <div
            onClick={
              rowData.iprAgreement === 0
                ? undefined
                : () => handleClick(rowData.id, rowData.title, rowData.albumPic, 'track')
            }
            style={{
              cursor: rowData.iprAgreement === 0 ? 'default' : 'pointer',
              opacity: rowData.iprAgreement === 0 ? 0.5 : 1,
              padding: '0px 20px 0px 17px'
            }}
          >
            <img src={View} alt="View" className='ViewIcon' width={24} height={20} />
          </div>
        </div>
      ),

    },


  ];

  return (
    <>
      <Header />
      <div className="space"></div>
      <section>
        <div className="container">
          <div className="row listRow">
            <div className="col-md-6">
              <a href="#" className="add-new-album" onClick={openAlbumPopup}>Add New Album</a>
              <span className='help-icon' onClick={openHelpPopup} data-tooltip-id="my-tooltip" data-tooltip-content="Help!"></span>
              <Tooltip id="my-tooltip" />
            </div>

          </div>
        </div>
      </section>
      {isFilterDivOpen && (
        <section className="filter-table">
          <div className='container'>
            <div className="row filter-row">
              <div className="col-md-3">
                <form>
                  <select onChange={(e) => setSelectedArtworkStatus(parseInt(e.target.value))} value={selectedArtworkStatus} className='input select-filter'>
                    <option value={-1} disabled>Filter By ArtWork</option>
                    <option value={0}>Upload</option>
                    <option value={1}>Submitted</option>
                    <option value={2}>Approved</option>
                    <option value={3}>Rejected</option>
                  </select>
                </form>
              </div>
              <div className="col-md-3">
                <form>
                  <select onChange={(e) => setSelectedAudioStatus(parseInt(e.target.value))} value={selectedAudioStatus} className='input select-filter'>
                    <option value={-1} disabled>Filter By Audio FIles</option>
                    <option value={0}>Upload</option>
                    <option value={1}>Submitted</option>
                  </select>
                </form>
              </div>
              <div className="col-md-3">
                <form>
                  <select onChange={(e) => setSelectedPrintProofStatus(parseInt(e.target.value))} value={selectedPrintProofStatus} className='input select-filter'>
                    <option value={-1} disabled>Filter By Proof</option>
                    <option value={0}>Awaiting</option>
                    <option value={1}>Accepted</option>
                  </select>
                </form>
              </div>
              <div className="col-md-3">
                <form>
                  <select onChange={(e) => setSelectedIprAgreement(parseInt(e.target.value))} value={selectedIprAgreement} className='input select-filter'>
                    <option value={-1} disabled>Filter By IRP</option>
                    <option value={0}>Awaiting</option>
                    <option value={1}>Submitted</option>
                  </select>
                </form>
              </div>


              <div className="col-md-12 align-right">
                <button onClick={handleFilter} className='btn-submit'>Filter</button>
                <button onClick={handleClearFilters} className='btn-submit'>Clear</button>
              </div>

            </div>
          </div>
        </section>
      )}

      <section className="list-table">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Table
                data={filteredData}
                columns={columns}
                pageSize={pageSize}
                onSort={handleSort}
                loading={loading}
                pagination={pagination}
                onChangePage={handleChangePage}
                total={totalPages}
                activePage={currentPage}
                limit={totalPages}
                headerHeight={60}
                height={500}
                width={100}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {helpPopupOpen && <Help closeHelpPopup={closeHelpPopup} openHelpPopup={openHelpPopup} />}
      {isAlbumPopupOpen && <UploadAfcAlbum closeAlbumPopup={closeAlbumPopup} album={editingAlbum} />}




      <ToastContainer />
    </>

  );
};

export default NFCWriterAppAlbum;  